import api from "./apiClient";

const endpoint = "reports";

export const createReport = (report) => {
	return api.post(endpoint, report);
};

export const getReportStats = () => {
	return api.get(`${endpoint}/stats`);
};

export const getAllReports = () => {
	return api.get(endpoint);
};

export const getReportById = (id) => {
	return api.get(`${endpoint}/${id}`);
};

export const updateReport = (id, report) => {
	return api.put(`${endpoint}/${id}`, report);
};

export const deleteReport = (id) => {
	return api.delete(`${endpoint}/${id}`);
};
